import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-sending-mail-icon',
  templateUrl: './communication-sending-mail.component.html'
})
export class CommunicationSendingMailComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
